import Grid from '@mui/material/Grid'
import { getFormattedUnit } from 'global/helpers/units'
import { cloneElement, type ReactElement } from 'react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

export interface KNQuoteAttributeProps {
  value: string
  prefix?: string
  suffix?: string
  icon?: ReactElement
}

const KNQuoteAttribute = ({ value, prefix, suffix, icon }: KNQuoteAttributeProps): ReactElement | null => {

  return (
    <Grid container>
      <Grid size={{ xs: 6, md: 6, lg: 4 }}>
        <Stack direction="row">
          {icon &&
            cloneElement(icon, {
              fontSize: 'small',
              sx: {
                color: 'info.focus',
                marginRight: 1,
              },
            })}

          {prefix && <Typography component="p" variant="p3" color="info.focus">
            {prefix}
          </Typography>}
        </Stack>
      </Grid>

      <Grid size={{ xs: 6, md: 6, lg: 8 }}>
        <Stack direction="column">
          <Typography component="p" variant="p3" color="primary.main" sx={{ wordWrap: 'break-word' }}>
            {value}
            {suffix && <small>&nbsp;{getFormattedUnit(suffix)}</small>}
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  )
}

export default KNQuoteAttribute
